module.exports = __webpack_public_path__ + "static/media/SF_UI_Display_Regular.4dcb9d94.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SF-UI-Display/SF_UI_Display_Regular.woff2
// module id = 211
// module chunks = 0